import { render, staticRenderFns } from "./typeTestReportSearch.vue?vue&type=template&id=80c7026e&scoped=true"
import script from "./typeTestReportSearch.vue?vue&type=script&lang=js"
export * from "./typeTestReportSearch.vue?vue&type=script&lang=js"
import style0 from "./typeTestReportSearch.vue?vue&type=style&index=0&id=80c7026e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c7026e",
  null
  
)

export default component.exports